// src/components/strumenti/NumeroMassimoSerieFV.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function NumeroMassimoSerieFV() {
  const [voc, setVoc] = useState("");
  const [coeff, setCoeff] = useState("-0.27");
  const [tempMin, setTempMin] = useState("-10");
  const [vmaxInverter, setVmaxInverter] = useState("");

  const Voc = leggiNumero(voc)||0;
  const beta = leggiNumero(coeff)||0;
  const T = leggiNumero(tempMin);
  const Vmax = leggiNumero(vmaxInverter)||0;

  const deltaT = T-25;
  const vocCorretto = Voc*(1+(beta/100)*deltaT);
  const numMax = (Voc>0 && Vmax>0) ? Math.floor(Vmax/vocCorretto) : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Voc pannello a STC (V)</label>
          <input value={voc} onChange={e=>setVoc(e.target.value)} style={inp} placeholder="Es. 41.8"/>
        </div>
        <div>
          <label style={lbl}>Coefficiente temperatura Voc (%/°C)</label>
          <input value={coeff} onChange={e=>setCoeff(e.target.value)} style={inp}/>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Temperatura minima di progetto (°C)</label>
          <input value={tempMin} onChange={e=>setTempMin(e.target.value)} style={inp}/>
        </div>
        <div>
          <label style={lbl}>Vmax DC inverter (V)</label>
          <input value={vmaxInverter} onChange={e=>setVmaxInverter(e.target.value)} style={inp} placeholder="Es. 1000"/>
        </div>
      </div>

      <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Numero massimo di pannelli in serie</div>
        <div style={{ fontSize:26, fontWeight:800, color:"#c2410c" }}>
          {numMax!==null ? numMax : "—"}
        </div>
        {numMax!==null && <div style={{ fontSize:11, color:"#6b7280", marginTop:4 }}>Voc stringa a {numMax} pannelli: {(vocCorretto*numMax).toFixed(1)} V</div>}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Verifica di sicurezza sul limite massimo di tensione DC — non stima la produzione energetica.
      </div>

      <button onClick={()=>{setVoc("");setCoeff("-0.27");setTempMin("-10");setVmaxInverter("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
